import { render } from "./ZircVenLongevity.vue?vue&type=template&id=6840d07d"
import script from "./ZircVenLongevity.vue?vue&type=script&lang=js"
export * from "./ZircVenLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__